import React from "react";
import Button from "../../../components/UI/button/GgButton";
import { AddIcon } from "../../../assets/icons";
import Input from "../../../components/UI/input/GgInput";
import { useModal } from "../../../customHooks/useModal";
import Modal from "../../../components/modal/Modal";
import ImageLoader from "../../../components/imageLoader/ImageLoader";
import { IPMBlock } from "../../../models/IPages";
import { $public } from "../../../http";
import { getImageExtensionFromBase64 } from "../../../utils";

function HeaderBlock({ data, setData, categoryType, actionData }: IPMBlock) {
  const modal = useModal();

  const imgSrc = data?.images?.[0] || $public(data?.mainImage);

  return (
    <>
      <div className="title">Header Block</div>
      <div className="step-list">
        <div className="step-item"> 
          <div className="step-title">Title</div>
          <div className="inputs-container">
            <Input
              type="text"
              placeholder="Enter title"
              value={data?.title}
              onChange={(val) => setData({ ...data, title: val })}
              disabled={!actionData?.edit}
            />
          </div>
        </div>
        <div className="step-item-row">
          <div className="step-item">
            <div className="step-title">Cover photo</div>
            <div className="inputs-container">
              <Button
                label={imgSrc ? "Change image" : "Add image"}
                icon={{ leftIcon: <AddIcon size="18" className="icon" /> }}
                stylesType="border"
                onPress={() => modal.openModal()}
                className="cover-image-button"
                disabled={!actionData?.edit}
              />
            </div>
          </div>
          {imgSrc && (
            <div className="cover-image">
              <img src={imgSrc} alt="" />
            </div>
          )}
        </div>
      </div>
      <Modal
        show={modal.showModal}
        onClose={modal.setModalShow}
        title="Add photo"
      >
        <ImageLoader
          label="Add image"
          // value={data?.mainImage}
          onChange={(img) => {
            const ext = getImageExtensionFromBase64(img);
            setData({
              ...data,
              images: [img],
              mainImage: `/image/page-management/${categoryType}/headerBlock1.${
                ext || "jpeg"
              }`,
            });
          }}
        />
      </Modal>
    </>
  );
}

export default HeaderBlock;
